module.exports = __webpack_public_path__ + "img/home-about-img3.80ce5137.png";